export default "__VITE_ASSET__4cf8c025__"